/**
 * @format
 */
import { Injectable } from "@angular/core";
import { EditorService } from "./editor.service";
import { BaseToolService } from "./base-tool.service";
import { SelectedElement, StackItemNode, StyleProperty, StylingStatus } from "../types/editor-types";
import { ToolAbstractService } from "./tool-abstract.service";
import { ToolExtraArguments } from "../types/tool-extra-arguments";
import { BoldUnderlineBaseService } from "./bold-underline.base.service";

@Injectable({ providedIn: "root" })
export class UnderlineToolService extends BoldUnderlineBaseService implements ToolAbstractService {
   constructor(private editorService: EditorService) {
      super("UNDERLINE");
   }

   getStyledElementsAsString(selection: Partial<SelectedElement>, extraArguments: Partial<ToolExtraArguments>): string {
      try {
         const { isParameter } = selection;
         const unUnderlineText = extraArguments.unUnderlineText;
         const currentRange = this.editorService.getRange();
         const templateContext = this.editorService.getTemplateContextElement();

         return this.getBoldStyledElementsAsString(currentRange, isParameter, templateContext, unUnderlineText);
      } catch (error) {
         this.editorService.logError(error, "Get Underline Styled Changes");
         return "";
      }
   }

   insertElementAndSaveRangeSelection(
      styledHtmlElements: string,
      isParameter: boolean,
      extraArguments: Partial<ToolExtraArguments>
   ): boolean {
      try {
         const unUnderlineText = extraArguments.unUnderlineText;
         const currentRange = this.editorService.getRange();
         const wrapperNode = this.editorService.getWrapperElementFromInnerHMTL(styledHtmlElements);
         const cleanWrapperNode = this.removeEmptyChildElements(wrapperNode);
         const templateContext = this.editorService.getTemplateContextElement();
         const setTemplateContext = (element: Element) => this.editorService.setTemplateContextElement(element);
         /**
          * Inserting a new element in position based on range selection
          */
         this.insertNodeInCurrentRange(
            currentRange,
            cleanWrapperNode,
            isParameter,
            unUnderlineText,
            templateContext,
            setTemplateContext
         );

         /**
          * saving the new selection range to keep the cursor pointer and selection
          */
         if (isParameter) {
            this.editorService.getNewSelectionRangeForParameter(this._START_ID, this._END_ID);
         } else {
            this.editorService.getNewSelectionRange(this._START_ID, this._END_ID);
         }

         return true;
      } catch (error) {
         this.editorService.logError(error, "Insert Range and Save on Underline");
         return false;
      }
   }
}
